import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const jumpUrlData = async (params: object) => {
  return await GET({ url: Api.jumpUrlData, params, showError: false })
}
